import { RecallCommunication } from "@/Common/Api/Communications/Dto/RecallCommunication";
import { Guid } from "@/Common/Models/Guid";

class Recall {
    public Id: string;
    public CreationDate: string;
    public CreatedBy: string;
    public LastUpdateDate: string;
    public LastUpdatedBy: string;
    public DeletionDate: string;
    public DeletedBy: string;
    public ArchivalDate: string;
    public ArchivedBy: string;
    public Type: string;
    public DueDate: string;
    public ShowInHome: boolean;
    public Notes: string;
    public IsCompleted: boolean;
    public PriorityLookupId: string;
    public SpecializationLookupId: string;
    public PatientLinkContactId: Guid;
    public CreatorContactId: string;
    public DoctorContactId: Guid;
    public PatientFirstName: string;
    public PatientLastName: string;
    public PatientPreferredName: string;
    public Status: string;

    public RecallCommunications: RecallCommunication[];
}

export { Recall };
